import { sum } from 'lib/array/arrayUtils'
import { safeDivideAndCeil } from 'lib/maths/mathUtils'
import { BundleOfferPackageOptionView } from 'selectors/offerPage/bundledOfferPageSelectors'
import { BaseOfferPackageOptionView, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import { divideAndCeilPricing } from './pricing'

function getBaseProps(view: BaseOfferPackageOptionView, nights: number): BaseOfferPackageOptionView {
  return {
    ...view,
    basePrice: safeDivideAndCeil(view.basePrice, nights),
    baseValue: safeDivideAndCeil(view.baseValue, nights),
    extraGuestsSurcharge: safeDivideAndCeil(view.extraGuestsSurcharge, nights),
    flightPrice: safeDivideAndCeil(view.flightPrice, nights),
    hotelPrice: safeDivideAndCeil(view.hotelPrice, nights),
    hotelValue: safeDivideAndCeil(view.hotelValue, nights),
    propertyFees: safeDivideAndCeil(view.propertyFees, nights),
    surcharge: safeDivideAndCeil(view.surcharge, nights),
    roomPrices: view.roomPrices?.map(v => safeDivideAndCeil(v, nights)),
    taxesAndFees: safeDivideAndCeil(view.taxesAndFees, nights),
    hotelTotal: safeDivideAndCeil(view.hotelTotal, nights),
  }
}

export function getBundlePackageViewNights(view:BundleOfferPackageOptionView): number | undefined {
  return sum(view.options.map(p => p.package.duration))
}

export function getBundlePackageViewPricingPerNight(view: BundleOfferPackageOptionView): BundleOfferPackageOptionView {
  return {
    ...view,
    ...getBaseProps(view, getBundlePackageViewNights(view)!),
    roomPrices: view.roomPrices?.map((v, i) => safeDivideAndCeil(v, view.options[i].package.duration)),
  }
}

export function getPackageViewPricingPerNight(view: OfferPackageOptionView, nightsSupplied?: number): OfferPackageOptionView {
  const nights = nightsSupplied ?? view.package.duration
  return {
    ...view,
    ...getBaseProps(view, nights),
    baseMemberPrice: safeDivideAndCeil(view.baseMemberPrice, nights),
    hotelMemberPrice: safeDivideAndCeil(view.hotelMemberPrice, nights),
    hotelMemberTotal: safeDivideAndCeil(view.hotelMemberTotal, nights),
    roomMemberPrices: view.roomMemberPrices?.map(v => safeDivideAndCeil(v, nights)),
    pricing: divideAndCeilPricing(view.pricing, nights, 'night'),
    memberPricing: view.memberPricing ? divideAndCeilPricing(view.memberPricing, nights, 'night') : undefined,
  }
}
